import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import {
  IPublicSuburbanV1GetOffersHistorySpoilerRequest,
  IMappers,
} from '../../../../repositories/valuation-offer-history/suburban/v1/get-offers-history-spoiler';
import { IOffersHistorySpoilerData } from '../../../../types/offerHistory';
import { prepareOffers } from '../../mappers';
import { prepareSpoilerCategoryFilters } from '../../mappers/prepareFilters';
import { EDealType } from '../../../../types/dealType';

export const createSuburbanOffersHistorySpoilerMapper = (
  parameters: IPublicSuburbanV1GetOffersHistorySpoilerRequest,
): IMappers<TMappedResponse200, TMappedResponse400> => ({
  200: response =>
    ({
      ...response,
      offers: prepareOffers(response.offers, EDealType.Sale),
      filters: prepareSpoilerCategoryFilters(response.filters),
    }) as IOffersHistorySpoilerData,
  400: ({ message }) => {
    return new HttpBadStatusCodeError({
      domain: 'fetchSuburbanOffersHistorySpoiler.ts',
      statusCode: 400,
      message: message || /* istanbul ignore next */ '',
      details: { ...parameters },
    });
  },
});

export type TMappedResponse200 = IOffersHistorySpoilerData;
export type TMappedResponse400 = HttpBadStatusCodeError;

export type TMappedResponse = TMappedResponse200 | TMappedResponse400;
